import {
  FormControl,
  Typography,
  Alert,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { FlexContainer, Spacer } from "../../components";
import { post } from "../../helpers/request";
import React, { useCallback, useState } from "react";
import styled from "styled-components";
import PublicLayout from "../../layouts/PublicLayout";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const FormContent = styled.div`
  width: 700px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  field-content {
    display: flex;
    width: 100%;
  }
  a {
    color: var(--color-text-primary);
  }
`;
const StyledAlert = styled(Alert)`
  align-self: stretch;
`;
const LabelField = styled(Typography)`
  padding: 8px 0;
`;

const CustomTitle = styled(Typography)`
  text-align: center;
  max-width: 900px;
`;

export const ResetPasswordView = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [successMessage, setSuccessMessage] = useState(null);
  const [error, setError] = useState(false);
  const [showPasswordForm, setShowPasswordForm] = useState({
    password: false,
    repeatPassword: false,
  });

  const [form, setForm] = useState({
    password: "",
    repeatPassword: "",
  });

  const handleFormChange = useCallback(
    (event) => {
      setForm({ ...form, [event.target.name]: event.target.value });
    },
    [form]
  );

  const handleShowPassword = useCallback(
    (name) => {
      setShowPasswordForm({
        ...showPasswordForm,
        [name]: !showPasswordForm[name],
      });
    },
    [showPasswordForm]
  );

  const handleResetPassword = useCallback(() => {
    if (form.password !== form.repeatPassword) {
      setSuccessMessage(null);
      setError("Las contraseñas no coinciden");
      return;
    } else if (!form.password || !form.repeatPassword) {
      setSuccessMessage(null);
      setError("Todos los campos son obligatorios");
      return;
    } else if (form.password.length < 8) {
      setSuccessMessage(null);
      setError("La contraseña debe tener al menos 8 caracteres");
      return;
    }
    post("/internal/alohub/password-reset/set", {
      password: form.password,
      token,
    })
      .then(() => {
        setError(null);
        navigate(
          `/login?successMessage=${encodeURIComponent(
            "Tu contraseña ha sido cambiada satisfactoriamente. Por favor, inicia sesión para continuar."
          )}`
        );
      })
      .catch(() => {
        setError("El link de restablecimiento de contraseña expiró.");
        setSuccessMessage(null);
      });
  }, [form.password, token, form.repeatPassword, navigate]);

  return (
    <PublicLayout
      onPrimaryClick={handleResetPassword}
      primaryLabel={"Reiniciar contraseña"}
    >
      <FlexContainer centered fullWidth vertical>
        <Spacer vertical size={5} />
        <CustomTitle variant="h2">Crea una nueva contraseña</CustomTitle>
        <Spacer vertical size={10} />
        <FormContent>
          <field-content>
            <FormControl variant="filled" fullWidth>
              <LabelField>Contraseña</LabelField>
              <OutlinedInput
                id="login-password"
                type={showPasswordForm.password ? "text" : "password"}
                value={form.password}
                onChange={handleFormChange}
                name="password"
                fullWidth
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => handleShowPassword("password")}
                      edge="end"
                    >
                      {showPasswordForm.password ? (
                        <Visibility />
                      ) : (
                        <VisibilityOff />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <Spacer horizontal size={2} />
            <FormControl fullWidth>
              <LabelField>Confirmar contraseña</LabelField>
              <OutlinedInput
                id="login-repeat-password"
                type={showPasswordForm.repeatPassword ? "text" : "password"}
                onChange={handleFormChange}
                name="repeatPassword"
                value={form.repeatPassword}
                fullWidth
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => handleShowPassword("repeatPassword")}
                      edge="end"
                    >
                      {showPasswordForm.repeatPassword ? (
                        <Visibility />
                      ) : (
                        <VisibilityOff />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </field-content>

          {(error || successMessage) && (
            <>
              <Spacer vertical size={2} />
              <FlexContainer fullWidth centered vertical>
                <StyledAlert severity={successMessage ? "success" : "error"}>
                  {successMessage ? successMessage : error}
                </StyledAlert>
              </FlexContainer>
            </>
          )}
          <Spacer vertical size={4} />
        </FormContent>
      </FlexContainer>
    </PublicLayout>
  );
};
